import C from './contact-channels79.js';

function s(r,t,e){var n=new C(e),o=n.getCountryCodesForCallingCode(r);return o?o.filter(function(a){return i(t,a,e)}):[]}function i(r,t,e){var n=new C(e);return n.selectNumberingPlan(t),n.numberingPlan.possibleLengths().indexOf(r.length)>=0}

export { s as default };
//# sourceMappingURL=contact-channels178.js.map
